/* Set price guard. Scuba Evolution, 2026-09-14.

   A set-price record (its handle ends in -set-price) is a BCD or gauge at the price a
   regulator set earns it. The gear builder adds it beside that set, with both lines sharing
   a _set_group, and that is the only place the price is honest. This keeps it so in the
   browser, on every page:

   - a record whose group has no set line (the set was removed from the cart, or the record
     was added from its own page) goes back to the shelf product at the shelf price, in the
     same size and colour;
   - an upgrade line (its handle starts with upgrade-: the mask, snorkel and fin rungs of a
     soft gear set, the R105 to Air 2 step of a rig) is a price difference with nothing behind
     it, so it is removed when the set it climbs from leaves the cart;
   - a line that needs another part beside it (_set_needs, the Air 2 upgrade needs a BCD in
     the set) is removed when that part goes;
   - a record or upgrade line never outnumbers the sets in its group.

   The store's plan cannot validate checkout, so an order that slips past still carries its
   _set_group and _set_part for the team to check before dispatch. */
(function(){
  if(window.__setPriceGuard) return;
  window.__setPriceGuard = true;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var SUFFIX = '-set-price';
  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var busy = false, again = false, rounds = 0;
  var nativeFetch = window.fetch ? window.fetch.bind(window) : null;
  if(!nativeFetch) return;

  function call(path, body){
    var init = { credentials:'same-origin', headers:{ 'Accept':'application/json' } };
    if(body){
      init.method = 'POST';
      init.headers['Content-Type'] = 'application/json';
      init.body = JSON.stringify(body);
    }
    return nativeFetch(ROOT + path, init).then(function(r){
      if(!r.ok) throw new Error(path + ' ' + r.status);
      return r.json();
    });
  }
  function isRecord(it){
    return typeof it.handle === 'string' && it.handle.length > SUFFIX.length &&
           it.handle.slice(-SUFFIX.length) === SUFFIX;
  }
  function isUpgrade(it){ return typeof it.handle === 'string' && it.handle.indexOf('upgrade-') === 0; }
  function props(it){ return it.properties || {}; }

  // what each broken line should be cut back to
  function plan(items){
    var sets = {}, parts = {}, jobs = [];
    items.forEach(function(it){
      var p = props(it), g = p._set_group;
      if(!g) return;
      if(p._set_role === 'base' && !isRecord(it)) sets[g] = (sets[g] || 0) + it.quantity;
      if(p._set_part && isRecord(it)) parts[g + '|' + p._set_part] = (parts[g + '|' + p._set_part] || 0) + it.quantity;
    });
    items.forEach(function(it){
      var p = props(it), g = p._set_group;
      var allowed = g ? (sets[g] || 0) : 0;
      if(p._set_needs) allowed = Math.min(allowed, g ? (parts[g + '|' + p._set_needs] || 0) : 0);
      if(isRecord(it)){
        if(it.quantity > allowed) jobs.push({ item:it, keep:allowed, swap:true });
      } else if(isUpgrade(it) || p._set_needs){
        if(it.quantity > allowed) jobs.push({ item:it, keep:allowed, swap:false });
      }
    });
    return jobs;
  }

  // cut the line back, then put the excess of a record in as the shelf product
  function fix(job){
    var it = job.item, excess = it.quantity - job.keep;
    return call('cart/change.js', { id:it.key, quantity:job.keep }).then(function(){
      if(!job.swap || excess < 1) return true;
      var shelf = it.handle.slice(0, -SUFFIX.length);
      return call('products/' + shelf + '.js').then(function(p){
        var want = (it.options_with_values || []).map(function(o){ return String(o.value); });
        var v = (p.variants || []).filter(function(x){
          var o = x.options || [];
          return o.length === want.length && o.every(function(val, i){ return String(val) === want[i]; });
        })[0] || ((p.variants || []).length === 1 ? p.variants[0] : null);
        if(!v || !v.available) return true;           // nothing to put back: the record simply goes
        var keep = {};
        Object.keys(props(it)).forEach(function(k){
          if(k.charAt(0) !== '_' && k !== 'Set') keep[k] = props(it)[k];
        });
        return call('cart/add.js', { items:[{ id:v.id, quantity:excess, properties:keep }] }).then(function(){ return true; });
      }).catch(function(){ return true; });
    }).catch(function(){ return false; });
  }

  function refresh(){
    var onCart = /\/cart\/?$/.test(location.pathname);
    var drawerOpen = !!document.querySelector('#CartDrawer[open], cart-drawer[open]');
    if(!(onCart || drawerOpen)) return;
    // one reload at most in a short window, so a cart that cannot be fixed never loops
    try {
      var last = +sessionStorage.getItem('spg-reload') || 0;
      if(Date.now() - last < 15000) return;
      sessionStorage.setItem('spg-reload', String(Date.now()));
    } catch(e){ return; }
    location.reload();
  }

  function check(){
    if(busy){ again = true; return; }
    if(rounds > 4) return;
    busy = true;
    call('cart.js').then(function(cart){
      var jobs = plan((cart && cart.items) || []);
      if(!jobs.length) return false;
      rounds++;
      return jobs.reduce(function(chain, job){
        return chain.then(function(changed){ return fix(job).then(function(ok){ return changed || ok; }); });
      }, Promise.resolve(false));
    }).then(function(changed){
      if(changed) refresh();
    }).catch(function(){ /* leave the cart as it is */ }).then(function(){
      busy = false;
      if(again){ again = false; setTimeout(check, 60); }
    });
  }

  // run after anything else on the page writes to the cart
  window.fetch = function(input, init){
    var url = typeof input === 'string' ? input : ((input && input.url) || '');
    var res = nativeFetch(input, init);
    if(CART_WRITE.test(url)) res.then(function(){ setTimeout(check, 40); }, function(){});
    return res;
  };
  if(window.XMLHttpRequest){
    var open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function(method, url){
      if(CART_WRITE.test(String(url || ''))) this.addEventListener('loadend', function(){ setTimeout(check, 40); });
      return open.apply(this, arguments);
    };
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', check);
  else check();
  window.addEventListener('pageshow', function(e){ if(e.persisted){ rounds = 0; check(); } });
})();
